











































import Vue from 'vue';
import Component from 'vue-class-component';
import {Bubble, IBubble, Graph, Section} from '../core/interface';
import bubble from "../components/bubble.vue";
import autocompleteItem from '../components/v-autocomplete-item.vue';
import {BubblesData, SectionData} from "../core/localData";
import {ApiClient} from "../api/api-client";
import {ApiService} from "../api/generated/api.service";
import {GetFrontBubbleData$Response, FrontBubbleData} from "../api/generated/api-types";

@Component({
    components: {
        bubble
    }
})

export default class Landing extends Vue {
    private api = new ApiService(new ApiClient());
    autocompleteItemTemplate: any = autocompleteItem;
    autocompleteInputAttrs: object = {placeholder: 'Otsi tulubaasist'};
    queryOptions: Section[] = SectionData.slice();
    state: IBubble[] = BubblesData;

    mounted() {
        this.getBubbles();
    }

    /*
        Computed - sorted bubbles by priority
     */
    get sortedBubbles(): IBubble[] {
        return this.state.sort((a: IBubble, b: IBubble) => a['priority'] - b['priority']);
    }

    /*
        Return label for autocomplete input
     */
    private getAutocompleteValueLabel(item: Graph): string {
        return item ? item.name : '';
    }

    /*
        Filter autocomplete suggestion based on typed text
     */
    private updateAutocomplete(text: string): void {
        this.queryOptions = SectionData.filter((option) => option.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
    }

    /*
        When user selects one of the values from dropdown
     */
    private onAutocompleteSelect(item: Section): void {
        this.sendGAEvent('Landing', 'click', 'Dropdown click', item.defaultGraphName);
        this.$router.push(`/graphs/viimsi/kokku/${item.value}/${item.defaultGraphName}`);
    }

    private sendGAEvent(category: string, action: string, label: string, value: string): void {
        Vue.gtm.trackEvent({
            category: category,
            action: action,
            label: label,
            value: value
        });
    }

    /*
        Get bubble data from API
     */
    private getBubbles(): void {
        this.api.singleData.getFrontBubbleData().then((res: GetFrontBubbleData$Response) => {
            this.state = this.updateState(res.frontBubbleData);
        });
    }

    private updateState(newData: FrontBubbleData): IBubble[] {
        const newState: IBubble[] = this.state.map(bubble => {
            const contents = bubble.contents.map(content => {
                if(content.id) {
                    const value = (newData as any)[content.id] || '0';
                    if(value) {
                        const prettyValue = this.prettifyBubbleValue(content.id, value);
                        return { ...content, value: prettyValue}
                    }
                    return { ...content, value}
                }
                return content;
            });
            return {...bubble, contents};
        })
        return newState;
    }

    private prettifyBubbleValue(id: string, value: number) {
        let valueString = Math.floor(value).toString(),
            valueArray = valueString.split(/(?=(?:...)*$)/),
            valueStringGrouped = valueArray.length === 2 && valueArray[0].length === 1 ? valueArray.join('') : valueArray.join(' ');

        switch(id) {
            case 'tulubaas':
            case 'füüsiliseIsikuTulumaks':
                return valueString.length >= 6 ? `${(Math.round((Math.floor(value) / 1000000) * 10) / 10).toString().replace('.', ',')} mln` : valueStringGrouped;
            case 'maksumaksjaid':
            case 'elanikeArv':
                return valueStringGrouped;
            case 'viimsiKeskmineBrutosissetulek':
            case 'potensiaalneDividendiTulumaks':
                return `${valueStringGrouped}€`;
            default:
                return value;
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/landing.vue